import store from '@/store';
import { RoutAllType, RouteParamsType } from '../types/route-params';

export const useRouteParams = defineStore(
  'routeParams',
  () => {
    const state = reactive<RouteParamsType>({
      routerAll: [],
      selectRoute: undefined,
      platFormId: '',
      refreshTime: undefined
    });
    const addSelectRoute = (data?: RoutAllType) => {
      state.selectRoute = data;
    };
    // 添加全部动态路由
    const addRouterAll = (data: RoutAllType[]) => {
      state.routerAll = data;
    };
    const addPlatFormId = (id: string) => {
      state.platFormId = id;
    };
    // 添加路由刷新时间
    const addRouterRefreshTime = (time: number) => {
      state.refreshTime = time;
    };
    return { state, addSelectRoute, addRouterAll, addPlatFormId, addRouterRefreshTime };
  },
  {
    persist: {
      storage: sessionStorage || undefined
    }
  }
);

export const useRouteParamsStore = () => {
  return useRouteParams(store);
};
